export default __webpack_public_path__ + "static/media/css.e7a1be92.png";